export class DateHelper {
  convertToSydneyTime(date: Date) {
    const options = {
      timeZone: 'Australia/Sydney', // Sydney is in AEST or AEDT depending on daylight saving
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    } as Intl.DateTimeFormatOptions;

    const formatter = new Intl.DateTimeFormat('en-AU', options);
    return new Date(formatter.format(date));
  }
}
